const PumpBrandsEnum = {
  TATSUNO: "Tatsuno",
  TOMINAGA: "Tominaga",
};

export default PumpBrandsEnum;
